<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white;">
            <br/>
            <div class="col-sm-10 col-xs-12">
                <b-row>
                    <b-col sm="4" class="col-sm-3 col-xs-5 text-right">
                        <label>รหัสชีท</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input placeholder="เช่น 22127"
                               type="text"
                               class="form-control"
                               v-model="form.code"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" class="col-sm-3 col-xs-5 text-right">
                        <label>ชีท</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input placeholder="เช่น A,B,MM"
                               type="text"
                               class="form-control"
                               v-model="form.name"/>
                    </b-col>
                </b-row>
                <br>
                <b-row>
                    <b-col sm="4" class="col-sm-3 col-xs-5 text-right">
                        <label>คำอธิบายชีท (ภาษาไทย)</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input type="text"
                               class="form-control"
                               v-model="form.name_th"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" class="col-sm-3 col-xs-5 text-right">
                        <label>ประเภทชีท</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <multiselect
                            v-model="form.sheet_type"
                            :options="optionSheetType"
                            @input="setSheetType(form.sheet_type)"
                            label="name"
                            track-by="name"
                            placeholder="กรุณาเลือกประเภทชีท">
                        </multiselect>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" class="col-sm-3 col-xs-5 text-right">
                        <label>จำนวน</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input
                            type="number"
                            class="form-control"
                            v-model="form.quantity" disabled/>
                    </b-col>
                </b-row>
                <br>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right"><label>ความยาว</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="number"
                        v-model="form.length"/></b-col>
                </b-row>
                <br>
                <template v-if="type===2">
                    <b-row sm="11">
                        <b-col sm="4" class="col text-right"><label>ความกว้าง</label></b-col>
                        <b-col sm="6"><input
                            class="form-control"
                            type="number"
                            v-model="form.width"/></b-col>
                    </b-row>
                    <br>
                </template>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right"><label>น้ำหนัก</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="number"
                        v-model="form.weight"/></b-col>
                </b-row>
                <br>
                <template v-if="type===1">
                    <b-row sm="11">
                        <b-col sm="4" class="col text-right"><label>เส้นผ่านศูนย์กลาง</label></b-col>
                        <b-col sm="6"><input
                            class="form-control"
                            type="number"
                            v-model="form.diameter"/></b-col>
                    </b-row>
                    <br>
                </template>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right"><label>ความหนา</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="number"
                        v-model="form.thickness"/></b-col>
                </b-row>
                <br>
                <b-row sm="11" v-if="type===2">
                    <b-col sm="4" class="col text-right"><label>ปาก</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="number"
                        v-model="form.border"/></b-col>
                </b-row>
                <div class="col text-center">
                    <b-button :disabled="form.onSave"
                              variant="success"
                              @click="saveSheet">
                        <icon name="save" style="width: 25px"></icon>
                        บันทึก
                    </b-button>
                    &nbsp;&nbsp;
                    <b-button class="btn btn-outline-secondary"
                              @click="goToSheetList">
                        <icon name="times" style="width: 25px"></icon>
                        ยกเลิก
                    </b-button>
                    &nbsp;&nbsp;
                    <b-button v-if="id" class="btn btn-danger"
                              @click="showDeleteModal">
                        <icon name="trash-alt" style="width: 25px"></icon>
                        ลบ
                    </b-button>
                </div>
                <br/>
            </div>
            <br/>
        </div>
        <!-- Modal -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteSheet">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import HeaderTitle from "../../HeaderTitle";
import Multiselect from "vue-multiselect";


export default {
    name: "sheet-information",
    components: {HeaderTitle, Multiselect},
    props: {
        id: {default: null}
    },
    data() {
        return {
            type: "",
            items: [
                {
                    text: "รายการสต็อคชีท",
                    to: {name: "sheet-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
        };
    },
    created() {
        //console.log(this.id);

        if (!this.id) {
            this.$store.dispatch('Sheet/clearFormData');
        }
        this.$store.dispatch('Sheet/getSheetTYPE');
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            form: state => {
                return state.Sheet.form;
            },
            optionSheetType: state => {
                return state.Sheet.sheet_type;
            }
        })
    },
    methods: {
        showDeleteModal() {
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        saveSheet() {
            if (!this.form.quantity) {
                this.form.quantity = 0;
            }
            if (this.form.length < 0) {
                this.form.length = 0;
            }
            if (this.form.width < 0) {
                this.form.width = 0;
            }
            if (this.form.weight < 0) {
                this.form.weight = 0;
            }
            if (this.form.diameter < 0) {
                this.form.diameter = 0;
            }
            if (this.form.thickness < 0) {
                this.form.thickness = 0;
            }
            if (this.form.border < 0) {
                this.form.border = 0;
            }
            if (!this.form.code) {
                alert('กรุณาใส่รหัสชีท');
            } else if (!this.form.name) {
                alert('กรุณาใส่ชื่อชีท')
            } else if (!this.form.sheet_type) {
                alert('กรุณาเลือกประเภทชีท')
            } else {
                this.form.onSave = true;
                this.$store.dispatch("Sheet/save", this.id).then(response => {
                    this.form.onSave = false;
                    if (response) {
                        this.goToSheetList();
                    } else {
                        alert("มีข้อมูลชีทนีอยู่ในคลังแล้ว กรุณากรอกชื่อหรือรหัสใหม่อีกครั้ง");
                    }
                });
            }
        },
        deleteSheet() {
            this.$store.dispatch("Sheet/delete", this.id).then(() => {
                this.hideDeleteModal();
                this.goToSheetList();
            });
        },
        setSheetType(type) {
            if (type) {
                this.type = type.id
            }

        },
        goToSheetList() {
            this.form.onSave = false;
            this.$router.push({name: "sheet-list"});
        }
    }
};
</script>

<style scoped>
.form-button {
    /*margin-left: 20%;*/
    display: flex;
    padding: 0;
}
</style>
